export default "__VITE_ASSET__DOuuWl7D__"